import { Text } from "@chakra-ui/react";
import React from "react";
export const IonLabelBeneath = ({ title }) => {
  return /* @__PURE__ */ React.createElement(Text, { textStyle: "body-6", color: "gray.600", mt: "8px" }, title);
};
